import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "ffaddb5d-ee39-4f0c-95cb-4c66fc4bb112",
    options: { imageUrl: `${config.ASSETS_URL}/01/29/task/task-1-item-1.svg` },
  },
  {
    id: "1478031b-311f-4805-a416-5c50c98e90a4",
    options: { imageUrl: `${config.ASSETS_URL}/01/29/task/task-1-item-2.svg` },
  },
  {
    id: "9b9189f7-dfd7-4b25-bc40-883b1af52007",
    options: { imageUrl: `${config.ASSETS_URL}/01/29/task/task-1-item-3.svg` },
  },
  {
    id: "f592fca1-fa0f-4a49-9001-edfa3fdded05",
    options: { imageUrl: `${config.ASSETS_URL}/01/29/task/task-1-item-4.svg` },
  },
  {
    id: "503e788f-46da-45e1-8f9e-b30c77f45bd1",
    options: { imageUrl: `${config.ASSETS_URL}/01/29/task/task-1-item-5.svg` },
  },
];

export const task: Task = {
  id: "996f13ae-d8f3-45a9-ac10-5c09253e4dec",
  solutionType: "order",
  type: "orderImages",
  options: {
    shuffle: true,
    imageViewType: "contain",
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "order",
  data: [
    "ffaddb5d-ee39-4f0c-95cb-4c66fc4bb112",
    "1478031b-311f-4805-a416-5c50c98e90a4",
    "9b9189f7-dfd7-4b25-bc40-883b1af52007",
    "f592fca1-fa0f-4a49-9001-edfa3fdded05",
    "503e788f-46da-45e1-8f9e-b30c77f45bd1",
  ],
};
